module.exports = __webpack_public_path__ + "static/media/parita-colore.0e971126.png";